module.exports = __webpack_public_path__ + "b37a893ce98ed7f497bd56ef5c07318c.svg";